import { LANGUAGE_CODES } from "./language";
import Cookies from "js-cookie";
import { tr, enUS } from "date-fns/locale";

export const setSystemLanguage = (language) => {
  Cookies.set("Accept-Language", language, { expires: 365 });
};

export const getSystemLanguage = () => Cookies.get("i18next") || "tr";

export const getFnsLocale = () => {
  const lang = getSystemLanguage();
  switch (lang) {
    case LANGUAGE_CODES.TR:
      return tr;
    case LANGUAGE_CODES.EN:
      return enUS;
    default:
      return tr;
  }
};

export const getLocale = () => {
  const lang = getSystemLanguage();
  console.log("getLocale", lang);
  switch (lang) {
    case LANGUAGE_CODES.TR:
      return LANGUAGE_CODES.TR;
    case LANGUAGE_CODES.EN:
      return LANGUAGE_CODES.EN;
    default:
      return tr;
  }
};
